import block_icons from '../icons/team';
import color_palette_list from '../gb-helper/color_palette';
import dashicon_list from '../gb-helper/dashicon_list';
import { font_family_detailed, all_font_families } from '../gb-helper/font_family_detailed';

const { registerBlockType } = wp.blocks;
const { __ } = wp.i18n;
const { InspectorControls,
    BlockControls,
    AlignmentToolbar,
    BlockAlignmentToolbar,
    RichText, MediaUploadCheck, MediaUpload } = wp.editor;
const { PanelBody, PanelRow,
    TextControl, Card, CardBody, SelectControl, Dashicon, Button, BaseControl, RangeControl, Panel, ColorIndicator, ColorPalette, ToggleControl } = wp.components;


registerBlockType('blocksbakery/team', {
    title: __('Team', 'blocks-bakery'),
    description: __(
        'Block bakery provides team block for beautifully describing the details of your team members. You can add the team member’s picture, name, and their social profiles in a beautiful manner.',
        'blocks-bakery'
    ),
    // common, formatting, layout, widgets, embed
    category: 'blocks-bakery',
    icon: block_icons.team_icon,
    keywords: [
        __('Team', 'blocks-bakery'),
        __('Group', 'blocks-bakery')
    ],
    supports: {
        html: false
    },
    attributes: {
        message: {
            type: 'array',
            source: 'children',
            selector: '.message-ctr'
        },
        heading_title: {
            type: 'html',
            default: 'h3'
        },
        heading_size: {
            type: 'number'
        },
        heading_fontfamily: {
            type: 'text',
            default: 'ABeeZee'
        },
        heading_fontweight: {
            type: 'number'
        },
        heading_lineheight: {
            type: 'number',
        },
        prefix_size: {
            type: 'number',
            default:16
        },
        imgPos: {
            type: 'string'
        },
        prefix_fontfamily: {
            type: 'text',
            default: 'ABeeZee'
        },
        prefix_fontweight: {
            type: 'number'
        },
        prefix_lineheight: {
            type: 'number',
        },
        para_title: {
            type: 'html',
            default: 'h3'
        },
        para_size: {
            type: 'number',
            default:16
        },
        para_fontfamily: {
            type: 'string',
            default: 'ABeeZee'
        },
        para_fontweight: {
            type: 'number'
        },
        para_lineheight: {
            type: 'number',
        },
        icon_size: {
            type: 'number',
            default: 30
        },
        text_colr: {
            type: 'string',
            default: 'black'
        },
        description_clr: {
            type: 'string',
            default: 'grey'
        },
        desg_clr: {
            type: 'string',
            default: 'black'
        },
        socail_list: {
            type: 'string',
            default: 'black'
        },
        title_spacing: {
            type: 'number',
            default: 1
        },
        description_spacing: {
            type: 'number',
            default: 1
        },
        desg_spacing: {
            type: 'number',
            default: 1
        },
        list_spacing: {
            type: 'number',
            default: 0
        },
        select_control: {
            type: 'text',
            default: "twitter"
        },
        select_control_icon2: {
            type: 'text',
            default: "facebook"
        },
        select_control_icon3: {
            type: 'text',
            default: "linkedin"
        },
        select_control_icon4: {
            type: 'text',
            default: "pinterest"
        },
        toggle_prefix: {
            type: 'boolean',
            default: true,
        },
        pos_content: {
            type: 'text',
            default: "center"
        },
        image_style: {
            type: 'string',
            default: "0"
        },
        image_styl: {
            type: 'string',
            default: 'normal'
        },
        v_alingment: {
            type: 'string'
        },
        heading_msg: {
            type: 'string',
            default: 'John Doe'
        },
        designation_msg: {
            type: 'string',
            default: "Designation"
        },
        description_msg: {
            type: 'string',
            default: "Click here to change this text. Lorem ipsum dolor sit amet, consectetur adipiscing elit. Ut elit tellus, luctus nec ullamcorper mattis, pulvinar dapibus leo."
        },
        w_size: {
            type: 'number',
            default: 100
        },
        h_size: {
            type: 'string',
            default: 'auto'
        },
        hover_icon: {
            type: 'string'
        },
        img_margin_top: {
            type: 'number',
            default: 0
        },
        img_margin_bottom: {
            type: 'number',
            default: 0
        },
        url_icon1: {
            type: 'string',
            default: "#"
        },
        url_icon2: {
            type: 'string',
            default: "#"
        },
        url_icon3: {
            type: 'string',
            default: "#"
        },
        url_icon4: {
            type: 'string',
            default: "#"
        },
        img_ID: {
            type: 'number'
        },
        img_URL: {
            type: 'string',
            source: 'attribute',
            attribute: 'src',
            selector: 'img'
        },
        img_alt: {
            type: 'string',
            source: 'attribute',
            attribute: 'alt',
            selector: 'img'
        },
        bgteamheadingtitle:{
            type:'string',
            default:'px',
        },
        titlelineheightpx:{
            type:'string',
            default:'px' 
        },
        prefixfontpxem:{
            type:'string',
            default:'px'
        },
        prefixlinghtpxem:{
            type:'string',
            default:'px'
        },
        descfontempx:{
            type:'string',
            default:'px',
        },
        descriptionlinghhidpxem:{
            type:'string',
            default:'px',
        },
        socialfontempxz:{
            type:'string',
            default:'px'
        },
    },
    edit: (props) => {


        var index = font_family_detailed.findIndex(x => x.family === props.attributes.para_fontfamily);
        var font_weight = font_family_detailed[index].variants
        var font_weight_list = []
        for (var i = 0; i < font_weight.length; i++) {
            font_weight_list.push({ label: font_weight[i], value: font_weight[i] })
        }

        var indexheading = font_family_detailed.findIndex(x => x.family === props.attributes.para_fontfamily);
        var font_weight_heading = font_family_detailed[indexheading].variants
        var font_weight_list_heading = []
        for (var i = 0; i < font_weight_heading.length; i++) {
            font_weight_list_heading.push({ label: font_weight_heading[i], value: font_weight_heading[i] })
        }

        
        var indexprefiexheading = font_family_detailed.findIndex(x => x.family === props.attributes.para_fontfamily);
        var font_weight_heading_prefix = font_family_detailed[indexprefiexheading].variants
        var font_weight_list_prefix = []
        for (var i = 0; i < font_weight_heading_prefix.length; i++) {
            font_weight_list_prefix.push({ label: font_weight_heading_prefix[i], value: font_weight_heading_prefix[i] })
        }


        const enbl_prefix = (val) => {
            if (val === true) {
                props.setAttributes({ prefix_display: 'block' })
            } else if (val === false) {
                props.setAttributes({ prefix_display: 'none' })
            }
        }

        const select_img = (img) => {
            props.setAttributes({
                img_ID: img.id,
                img_URL: img.url,
                img_alt: img.alt
            })
        };

        const remove_img = () => {
            props.setAttributes({
                img_ID: null,
                img_URL: null,
                img_alt: null
            })
        }
        const imgStyle = (val) => {
            if (val === 'normal') {
                props.setAttributes({ w_size: props.attributes.w_size })
                props.setAttributes({ h_size: 'auto' })
                props.setAttributes({ image_style: '' })
            } else if (val === 'circle') {
                props.setAttributes({ w_size: props.attributes.w_size })
                props.setAttributes({ h_size: props.attributes.w_size })
                props.setAttributes({ image_style: '50%' })
            } else if (val === 'square') {
                props.setAttributes({ w_size: props.attributes.w_size })
                props.setAttributes({ h_size: props.attributes.w_size })
                props.setAttributes({ image_style: '10%' })
            }
        }
        const title_toggle = () => {
            var x = document.getElementById('title-toggle');
            if (x.style.display === "none") {
                x.style.display = "block";
            }
            else {
                x.style.display = "none";
            }
        }
        const prifex_toggle = () => {
            var x = document.getElementById('prifex-toggle');
            if (x.style.display === "none") {
                x.style.display = "block";
            }
            else {
                x.style.display = "none";
            }
        }
        const description_toggle = () => {
            var x = document.getElementById('description-toggle');
            if (x.style.display === "none") {
                x.style.display = "block";
            }
            else {
                x.style.display = "none";
            }
        }
        const toggle_enble = () => {
            var x = document.getElementById('icon_hover')
            if (x.style.display === "none") {
                x.style.display = "block";
            }
            else {
                x.style.display = "none";
            }
        };
        const changeBackground = (e) => {
            e.target.style.color = props.attributes.hover_icon
        }
        const sameColor = (e) => {
            e.target.style.color = props.attributes.socail_list
        }
        const titleFontPx = () => {
          var x= document.getElementById("titlefontpxunderline");
          var y= document.getElementById("titlefontemunderline");
            props.setAttributes({bgteamheadingtitle: 'px'})
            x.style.textDecoration="underline"
            y.style.textDecoration="none"
        }
        const titleFontEm = () => {
            var x= document.getElementById("titlefontpxunderline");
            var y= document.getElementById("titlefontemunderline");
            props.setAttributes({bgteamheadingtitle: 'em'})
            x.style.textDecoration="none"
            y.style.textDecoration="underline"
        }
        const titleLinehieghtpx = () => {
           props.setAttributes({titlelineheightpx: 'px'})
        }
        const titleLinehieghtEm = () => {
            props.setAttributes({titlelineheightpx: 'em'})
        }
        const prefixFontPx = () => {
            var x = document.getElementById("prefixfontpx");
            var y = document.getElementById("prefixfontex");
            x.style.textDecoration = "underline";
            y.style.textDecoration = "none";
           props.setAttributes({prefixfontpxem: 'px'})
        }
        const prefixFontEm = () => {
            var x = document.getElementById("prefixfontpx");
            var y = document.getElementById("prefixfontex");
            x.style.textDecoration = "none";
            y.style.textDecoration = "underline";
            props.setAttributes({prefixfontpxem: 'em'})
        }
        const prefixLineheightPx = () => {
           props.setAttributes({prefixlinghtpxem: 'px'})
        }
        const prefixLineheightEm = () => {
            props.setAttributes({prefixlinghtpxem: 'em'})
        }
        const descriptionFontPx = () => {
          var x = document.getElementById("descriptionFontpx");
          var y = document.getElementById("descriptionFontem");
          x.style.textDecoration = "underline";
          y.style.textDecoration = "none";
          props.setAttributes({descfontempx: 'px'})
        }
        const descriptionFontEm = () => {
            var x = document.getElementById("descriptionFontpx");
          var y = document.getElementById("descriptionFontem");
          x.style.textDecoration = "none";
          y.style.textDecoration = "underline";
          props.setAttributes({descfontempx: 'em'})
        }
        const descriptionLineheightPx = () => {
            var x = document.getElementById("descriptionLineheightpx");
            var y = document.getElementById("descriptionLineheightem");
            x.style.textDecoration = "underline";
            y.style.textDecoration = "none";
            props.setAttributes({descriptionlinghhidpxem : 'px'})
        }
        const descriptionLineheightEm = () => {
            var x = document.getElementById("descriptionLineheightpx");
            var y = document.getElementById("descriptionLineheightem");
            x.style.textDecoration = "none";
            y.style.textDecoration = "underline";
            props.setAttributes({descriptionlinghhidpxem : 'em'})
        }
        const socialFontPx = () => {
            var x = document.getElementById("socailfontpx");
            var y = document.getElementById("socailfontem");
            x.style.textDecoration="underline";
            y.style.textDecoration="none";
            props.setAttributes({socialfontempxz: 'px'})
        }
        const socialFontEm = () => {
            var x = document.getElementById("socailfontpx");
            var y = document.getElementById("socailfontem");
            x.style.textDecoration="none";
            y.style.textDecoration="underline";
            props.setAttributes({socialfontempxz: 'em'})

        }
        const titleReset = () => {
            props.setAttributes({ heading_size: '' })
            props.setAttributes({ heading_fontfamily: 'ABeeZee' })
            props.setAttributes({ heading_lineheight: '15' })
            props.setAttributes({ heading_fontweight: '' })
        }
        const prefixReset = () => {
            props.setAttributes({ prefix_size: '16' })
            props.setAttributes({ prefix_fontfamily: 'ABeeZee' })
            props.setAttributes({ prefix_lineheight: '16' })
            props.setAttributes({ prefix_fontweight: '' })
        }
        const descriptionReset = () => {
            props.setAttributes({ para_size: '16' })
            props.setAttributes({ para_fontfamily: 'ABeeZee' })
            props.setAttributes({ para_lineheight: '16' })
            props.setAttributes({ para_fontweight: '' })
        }
        const img_pos = (val) => {
            if (val === 'left') {
                props.setAttributes({ imgPos: 'left' })
            } else if (val === 'right') {
                props.setAttributes({ imgPos: 'right' })
            } else if (val === 'center') {
                props.setAttributes({ imgPos: 'none' })
            }
        }
        return [
            <div>
                <InspectorControls>
                    <PanelBody title={__('Image', 'blocks-bakery')} initialOpen={false}>
                        <BaseControl>
                            <BaseControl.VisualLabel>
                                Team Member Image
                                <br></br>
                                <br></br>
                            </BaseControl.VisualLabel>
                            {props.attributes.img_ID ? (
                                <div className="image-ctr" style={{ margin: '0px 10px' }}>
                                    <img src={props.attributes.img_URL}
                                        alt={props.attributes.img_alt} />
                                    {props.isSelected ? (
                                        <Button className="btn-remove" onClick={remove_img}>
                                            <Dashicon icon='no' size='20' />
                                        </Button>
                                    ) : null}
                                </div>
                            ) : (
                                <MediaUploadCheck  >
                                    <MediaUpload
                                        allowedType={['image']}
                                        value={props.attributes.img_ID}
                                        onSelect={select_img}
                                        render={({ open }) => (
                                            <Button className={"button button-large"} onClick={open}>
                                                {__('Upload Image', 'blocks-bakery')}
                                            </Button>
                                        )} >
                                    </MediaUpload>
                                </MediaUploadCheck>
                            )}
                        </BaseControl>
                        <SelectControl
                            label="Position"
                            options={[
                                { label: 'Above', value: 'center' },
                                { label: 'Left', value: 'left' },
                                { label: 'Right', value: 'right' },
                            ]}
                            value={props.attributes.pos_content}
                            onChange={(new_val) => {
                                props.setAttributes({ pos_content: new_val })
                                img_pos(new_val)
                            }}
                            style={{ display: "flex" }}
                        />
                        <SelectControl
                            label="Image Style"
                            options={[
                                { label: 'Normal', value: 'normal' },
                                { label: 'Circle', value: 'circle' },
                                { label: 'Square', value: 'square' },
                            ]}
                            value={props.attributes.image_styl}
                            onChange={(new_val) => {
                                props.setAttributes({ image_styl: new_val })
                                imgStyle(new_val)
                            }}
                        />
                        <RangeControl
                            allowReset={true}
                            label="Width"
                            min={0}
                            max={500}
                            initialPosition={100}
                            value={props.attributes.w_size}
                            onChange={(new_val) => {
                                props.setAttributes({ w_size: new_val })
                            }}
                        />
                    </PanelBody>
                  
                    <PanelBody title={__("Social Links", "blocks-bakery")} initialOpen={false}>
                    <ToggleControl
                        label="Enable Social Links"
                        checked={props.attributes.toggle_prefix}
                        onChange={(new_val) => {
                            props.setAttributes({ toggle_prefix: new_val })
                            enbl_prefix(new_val)
                        }}
                    />   
                        <div className="bb-team-icons-wrapper" style={{ display: props.attributes.prefix_display }}>
                        <PanelBody title={__("Twitter")} initialOpen={false} >
                            <p>Icon</p>
                            <Card>
                                <CardBody>
                                    <SelectControl
                                        label='Select-dash'
                                        value={props.attributes.select_control}
                                        options={dashicon_list}
                                        onChange={(new_val) => {
                                            props.setAttributes({ select_control: new_val })
                                        }} />
                                    <Dashicon icon={props.attributes.select_control}
                                    />
                                    <hr />
                                    <p>URL</p>
                                    <TextControl
                                        value={props.attributes.url_icon1}
                                        onChange={(new_val) => {
                                            props.setAttributes({ url_icon1: new_val })
                                        }} />
                                </CardBody>
                            </Card>
                        </PanelBody>
                        <PanelBody title={__("Facebook")} initialOpen={false}>
                            <p>Icon</p>
                            <Card>
                                <CardBody>
                                    <SelectControl
                                        label='Select-dash'
                                        value={props.attributes.select_control_icon2}
                                        options={dashicon_list}
                                        onChange={(new_val) => {
                                            props.setAttributes({ select_control_icon2: new_val })
                                        }} />
                                    <Dashicon icon={props.attributes.select_control_icon2}
                                    />
                                    <hr />
                                    <p>URL</p>
                                    <TextControl
                                        value={props.attributes.url_icon2}
                                        onChange={(new_val) => {
                                            props.setAttributes({ url_icon2: new_val })
                                        }} />
                                </CardBody>
                            </Card>
                        </PanelBody>
                        <PanelBody title={__("Linkedin")} initialOpen={false}>
                            <p>Icon</p>
                            <Card>
                                <CardBody>
                                    <SelectControl
                                        label='Select-dash'
                                        value={props.attributes.select_control_icon3}
                                        options={dashicon_list}
                                        onChange={(new_val) => {
                                            props.setAttributes({ select_control_icon3: new_val })
                                        }} />
                                    <Dashicon icon={props.attributes.select_control_icon3}
                                    />
                                    <hr />
                                    <p>URL</p>
                                    <TextControl
                                        value={props.attributes.url_icon3}
                                        onChange={(new_val) => {
                                            props.setAttributes({ url_icon3: new_val })
                                        }} />
                                </CardBody>
                            </Card>
                        </PanelBody>
                        <PanelBody title={__("Pintrest")} initialOpen={false}>
                            <p>Icon</p>
                            <Card>
                                <CardBody>
                                    <SelectControl
                                        label='Select-dash'
                                        value={props.attributes.select_control_icon4}
                                        options={dashicon_list}
                                        onChange={(new_val) => {
                                            props.setAttributes({ select_control_icon4: new_val })
                                        }} />
                                    <Dashicon icon={props.attributes.select_control_icon4}
                                    />
                                    <hr />
                                    <p>URL</p>
                                    <TextControl
                                        value={props.attributes.url_icon4}
                                        onChange={(new_val) => {
                                            props.setAttributes({ url_icon4: new_val })
                                        }} />
                                </CardBody>
                            </Card>
                        </PanelBody>
                        </div>
                    
                    </PanelBody>
                    <PanelBody title={__("Typography", "blocks-bakery")} initialOpen={false}>
                        <SelectControl
                            label="Title Tag"
                            options={[
                                { label: 'h1', value: 'h1' },
                                { label: 'h2', value: 'h2' },
                                { label: 'h3', value: 'h3' },
                                { label: 'h4', value: 'h4' },
                                { label: 'h5', value: 'h5' },
                                { label: 'h6', value: 'h6' },
                            ]}
                            value={props.attributes.heading_title}
                            onChange={(new_val) => {
                                props.setAttributes({ heading_title: new_val })
                            }}
                        />
                        <hr />
                        <h2 style={{ fontSize: 13 }}>Title</h2>
                        <PanelRow>
                            <p>Typography</p>
                            <div>
                                <Button onClick={titleReset} style={{ paddingLeft: 7, paddingRight: 7 }}><span><Dashicon icon="image-rotate" style={{ fontSize: 15 }} /></span></Button>
                                <Button style={{ paddingLeft: 7, paddingRight: 7 }}><span><Dashicon icon="admin-tools" style={{ fontSize: 15 }} onClick={title_toggle} /></span></Button>
                            </div>
                        </PanelRow>
                        <Card id="title-toggle" style={{ display: "none" }}>
                            <CardBody style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 10, paddingRight: 10 }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <p style={{ marginRight: 46 }}>Font Size</p>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                    <Button onClick={titleFontPx} id="titlefontpxunderline" style={{  fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                    <Button onClick={titleFontEm} id="titlefontemunderline"   style={{  fontSize: 15, padding: 0 }} ><span style={{ height: 30 }}>em</span></Button>
                                </div>
                                <div className="range-controller-main">
                                    <div className="textcoloring">
                                    </div>

                                    <div className="range-controler" style={{display:"flex"}}>
                                
                                        
                                <div style={{marginRight:"10px",width:"100%"}}>
                                    
                                        <RangeControl
                                            beforeIcon="editor-textcolor"
                                            min={0}
                                            max={100}
                                            initialPosition={25}
                                            step={0.1}
                                            value={props.attributes.heading_size}
                                            onChange={(new_val) => {
                                                props.setAttributes({ heading_size: new_val })
                                            }}
                                        />
                                      
                                        </div>
                                        <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '12px',width:"22%",height:"30px", padding:"6px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                            props.setAttributes({heading_size:"25"})
                                            }}> Reset 
                                        </Button>
                                    </div>
                                    <SelectControl
                                        label="Font Family"
                                        options={all_font_families}
                                        onChange={(new_val) => {
                                            props.setAttributes({ heading_fontfamily: new_val })
                                        }}
                                        value={props.attributes.heading_fontfamily}
                                    />
                                    <SelectControl
                                        label="Font Weight"
                                       options={font_weight_list_heading}
                                        onChange={(new_val) => {
                                            props.setAttributes({ heading_fontweight: new_val })
                                        }}
                                        value={props.attributes.heading_fontweight}
                                    />
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <p style={{ marginRight: 30 }}>Line Height</p>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                        <Button onClick={titleLinehieghtpx} primaray style={{ textDecoration: "underline", fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                        <Button onClick={titleLinehieghtEm} primaray style={{ fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                    </div>
                                    <div className="range-controler" style={{display:"flex"}}>      
                                <div style={{marginRight:"10px",width:"100%"}}>
                                    <RangeControl
                                        beforeIcon="editor-textcolor"
                                        min={0}
                                        max={300}
                                        step={0.1}
                                        initialPosition={15}
                                        value={props.attributes.heading_lineheight}
                                        onChange={(new_val) => {
                                            props.setAttributes({ heading_lineheight: new_val })
                                        }}
                                    />
                                </div>
                                <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '12px',width:"22%",height:"30px", padding:"6px",color:"#007cba"
                                            }}
                                            onClick={() => {       
                                            props.setAttributes({heading_lineheight:"15"})
                                            }}> Reset 
                                        </Button>
                                        </div>
                                        </div>
                            </CardBody>
                        </Card>
                        <hr />
                        <h2 style={{ fontSize: 13 }}>Prefix</h2>
                        <PanelRow>
                            <p>Typography</p>
                            <div>
                                <Button onClick={prefixReset} style={{ paddingLeft: 7, paddingRight: 7 }}><span><Dashicon icon="image-rotate" style={{ fontSize: 15 }} /></span></Button>
                                <Button style={{ paddingLeft: 7, paddingRight: 7 }}><span><Dashicon icon="admin-tools" style={{ fontSize: 15 }} onClick={prifex_toggle} /></span></Button>
                            </div>
                        </PanelRow>
                        <Card id="prifex-toggle" style={{ display: "none" }}>
                            <CardBody style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 10, paddingRight: 10 }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <p style={{ marginRight: 46 }}>Font Size</p>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                    <Button onClick={prefixFontPx} id="prefixfontpx" style={{  fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                    <Button onClick={prefixFontEm} id="prefixfontex" style={{  fontSize: 15, padding: 0 }} ><span style={{ height: 30 }}>em</span></Button>
                                </div>
                                <div className="range-controller-main">
                                <div className="range-controler" style={{display:"flex"}}>
                                         <div style={{marginRight:"10px",width:"100%"}}>
                                        <RangeControl
                                            beforeIcon="editor-textcolor"
                                            min={0}
                                            max={300}
                                            step={0.1}
                                            initialPosition={16}
                                            value={props.attributes.prefix_size}
                                            onChange={(new_val) => {
                                                props.setAttributes({ prefix_size: new_val })
                                            }}
                                        />
                                        </div>
                                        <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '12px',width:"22%",height:"30px", padding:"6px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                          
                                            props.setAttributes({prefix_size:"16"})
                                            }}> Reset 
                                        </Button>

                                        </div>
                                    
                                    <SelectControl
                                        label="Font Family"
                                        options={all_font_families}
                                        onChange={(new_val) => {
                                            props.setAttributes({ prefix_fontfamily: new_val })
                                        }}
                                        value={props.attributes.prefix_fontfamily}
                                    />
                                    <SelectControl
                                        label="Font Weight"
                                        options={font_weight_list_prefix}
                                        onChange={(new_val) => {
                                            props.setAttributes({ prefix_fontweight: new_val })
                                        }}
                                        value={props.attributes.prefix_fontweight}
                                    />
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <p style={{ marginRight: 30 }}>Line Height</p>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                        <Button onClick={prefixLineheightPx} onChange primaray style={{ textDecoration: "underline", fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                        <Button onClick={prefixLineheightEm} primaray style={{ fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                    </div>
                                    <div className="range-controler" style={{display:"flex"}}>
                                         <div style={{marginRight:"10px",width:"100%"}}>
                                    <RangeControl
                                        beforeIcon="editor-textcolor"
                                        min={0}
                                        max={300}
                                        step={0.1}
                                        initialPosition={16}
                                        value={props.attributes.prefix_lineheight}
                                        onChange={(new_val) => {
                                            props.setAttributes({ prefix_lineheight: new_val })
                                        }}
                                    />
                                    </div>
                                           <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '12px',width:"22%",height:"30px", padding:"6px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                          
                                            props.setAttributes({prefix_lineheight:"16"})
                                            }}> Reset 
                                        </Button>

                                    </div>
                                </div>
                            </CardBody>
                        </Card>
                        <hr />
                        <h2 style={{ fontSize: 13 }}>Description</h2>
                        <PanelRow>
                            <p>Typography</p>
                            <div>
                                <Button onClick={descriptionReset} style={{ paddingLeft: 7, paddingRight: 7 }}><span><Dashicon icon="image-rotate" style={{ fontSize: 15 }} /></span></Button>
                                <Button style={{ paddingLeft: 7, paddingRight: 7 }}><span><Dashicon icon="admin-tools" style={{ fontSize: 15 }} onClick={description_toggle} /></span></Button>
                            </div>
                        </PanelRow>
                        <Card id="description-toggle" style={{ display: "none" }}>
                            <CardBody style={{ paddingTop: 16, paddingBottom: 16, paddingLeft: 10, paddingRight: 10 }}>
                                <div style={{ display: "flex", alignItems: "center" }}>
                                    <p style={{ marginRight: 46 }}>Font Size</p>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                    <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                        <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                    <Button onClick={descriptionFontPx} id="descriptionFontpx"  style={{ fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                    <Button onClick={descriptionFontEm} id="descriptionFontem"   style={{ fontSize: 15, padding: 0 }} ><span style={{ height: 30 }}>em</span></Button>
                                </div>
                                <div className="range-controller-main">
                             
                                <div className="range-controler" style={{display:"flex"}}>       
                                <div style={{marginRight:"10px",width:"100%"}}>
                                        <RangeControl 
                                            beforeIcon="editor-textcolor"
                                            min={0}
                                            max={100}
                                            initialPosition={16}
                                            step={0.1}
                                            value={props.attributes.para_size}
                                            onChange={(new_val) => {
                                                props.setAttributes({ para_size: new_val })
                                            }}
                                        />
                                        </div>

                                        <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '12px',width:"22%",height:"30px", padding:"6px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                          
                                            props.setAttributes({para_size:"16"})
                                            }}> Reset 
                                        </Button>

                                    </div>
                                    <SelectControl
                                        label="Font Family"
                                        options={all_font_families}
                                        onChange={(new_val) => {
                                            props.setAttributes({ para_fontfamily: new_val })
                                        }}
                                        value={props.attributes.para_fontfamily}
                                    />
                                    <SelectControl
                                        label="Font Weight"
                                       options={font_weight_list}
                                        onChange={(new_val) => {
                                            props.setAttributes({ para_fontweight: new_val })
                                        }}
                                        value={props.attributes.para_fontweight}
                                    />
                                    <div style={{ display: "flex", alignItems: "center" }}>
                                        <p style={{ marginRight: 30 }}>Line Height</p>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                        <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                            <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                        <Button onClick={descriptionLineheightPx} id="descriptionLineheightpx"  style={{ textDecoration: "underline", fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                        <Button onClick={descriptionLineheightEm} id="descriptionLineheightem" style={{ fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                                    </div>

                                    <div className="range-controler" style={{display:"flex"}}>
                                <div style={{marginRight:"10px",width:"100%"}}>
                                    <RangeControl
                                        beforeIcon="editor-textcolor"
                                        min={0}
                                        max={300}
                                        step={0.1}
                                        initialPosition={16}
                                        value={props.attributes.para_lineheight}
                                        onChange={(new_val) => {
                                            props.setAttributes({ para_lineheight: new_val })
                                        }}
                                    />
                                    </div>

                                        <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '12px',width:"22%",height:"30px", padding:"6px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                          
                                            props.setAttributes({para_lineheight:"16"})
                                            }}> Reset 
                                        </Button>
                                </div>
                                </div>
                            </CardBody>
                        </Card>
                        <hr />
                        <h2 style={{ fontSize: 13 }}>Social Icons</h2>
                        <PanelRow>
                            <p style={{ marginTop: 5 }}>Font Size</p>
                            <div style={{ display: "flex", alignItems: "center" }}>
                                <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                    <span> <Dashicon icon="desktop" style={{ fontSize: 15 }} /></span></Button>
                                <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                    <span><Dashicon icon="tablet" style={{ fontSize: 15 }} /></span></Button>
                                <Button style={{ padding: 1, marginRight: 4, boxShadow: 0, height: 20, backgroundColor: "#e4e5e5", color: "#23282d", borderRadius: "50%" }}>
                                    <span><Dashicon icon="phone" style={{ fontSize: 15 }} /></span></Button>
                                <Button onClick={socialFontPx} id="socailfontpx" style={{ fontSize: 15, paddingLeft: 5, paddingRight: 5 }}><span style={{ height: 30 }}>px</span></Button>
                                <Button onClick={socialFontEm} id="socailfontem"  style={{ fontSize: 15, padding: 0 }}><span style={{ height: 30 }}>em</span></Button>
                            </div>
                        </PanelRow>
                        <div className="range-controler" style={{display:"flex"}}>               
                        <div style={{marginRight:"10px",width:"100%"}}>
                        <RangeControl
                            beforeIcon="editor-textcolor"
                            step={0.1}
                            initialPosition={30}
                            min={0}
                            max={50}
                            value={props.attributes.icon_size}
                            onChange={(new_val) => {
                                props.setAttributes({ icon_size: new_val })
                            }}
                        />
                        </div>
                                       <Button style={{
                                            background: 'transparent', border: '1px solid #007cba', fontSize: '12px',width:"22%",height:"30px", padding:"6px",color:"#007cba"
                                            }}
                                            onClick={() => {
                                          
                                            props.setAttributes({icon_size:"30"})
                                            }}> Reset 
                                        </Button>
                        </div>
                    </PanelBody>
                    <PanelBody
                        title={__('Color Settings', "blocks-bakery")}
                        initialOpen={false} >
                        <p>Text Color <span> <ColorIndicator
                            style={{ backgroundColor: props.attributes.text_colr }} /></span></p>
                        <ColorPalette
                            colors={color_palette_list}
                            onChange={(new_val) => {
                                props.setAttributes({ text_colr: new_val })

                            }}
                            value={props.attributes.text_colr}
                        />
                        <div style={{ paddingTop: 13, paddingBottom: 13 }}></div>
                        <p>Designation Color <span> <ColorIndicator
                            style={{ backgroundColor: props.attributes.description_clr }} /></span></p>
                        <ColorPalette
                            colors={color_palette_list}
                            onChange={(new_val) => {
                                props.setAttributes({ description_clr: new_val })
                            }}
                            value={props.attributes.description_clr}
                        />
                        <div style={{ paddingTop: 13, paddingBottom: 13 }}></div>
                        <p>Description Color <span> <ColorIndicator
                            style={{ backgroundColor: props.attributes.desg_clr }} /></span></p>
                        <ColorPalette
                            colors={color_palette_list}
                            onChange={(new_val) => {
                                props.setAttributes({ desg_clr: new_val })
                            }}
                            value={props.attributes.desg_clr}
                        />
                        <div style={{ paddingTop: 13, paddingBottom: 13 }}></div>
                        <p>Social Icon Color <span> <ColorIndicator
                            style={{backgroundColor: props.attributes.socail_list}}/></span></p>
                        <ColorPalette
                            colors={color_palette_list}
                            onChange={(new_val) => {
                                props.setAttributes({ socail_list: new_val })
                            }}
                            value={props.attributes.socail_list}
                        />
                        <div style={{ paddingTop: 13, paddingBottom: 13 }}></div>
                        <p>Social Icon Hover Color <span> <ColorIndicator
                            style={{backgroundColor: props.attributes.hover_icon}}/></span></p>
                        <ColorPalette
                            colors={color_palette_list}
                            onChange={(new_val) => {
                                props.setAttributes({ hover_icon: new_val })
                            }}
                            value={props.attributes.hover_icon}
                        />
                    </PanelBody>
                    <PanelBody title={__("Spacing", "blocks-bakery")} initialOpen={false}>
                        <RangeControl
                            label="Title Bottom Spacing"
                            allowReset={true}
                            min={0}
                            max={200}
                            initialPosition={1}
                            onChange={(new_val) => {
                                props.setAttributes({ title_spacing: new_val })
                            }}
                            value={props.attributes.title_spacing}
                        />
                        <RangeControl
                            label="Designation Bottom Spacing"
                            allowReset={true}
                            min={0}
                            max={200}
                            initialPosition={1}
                            onChange={(new_val) => {
                                props.setAttributes({ description_spacing: new_val })
                            }}
                            value={props.attributes.description_spacing}
                        />
                        <RangeControl
                            label="Description Bottom Spacing"
                            allowReset={true}
                            min={0}
                            max={200}
                            initialPosition={1}
                            onChange={(new_val) => {
                                props.setAttributes({ desg_spacing: new_val })
                            }}
                            value={props.attributes.desg_spacing}
                        />
                        <RangeControl
                            label="Inner Social  Icon Spacing"
                            allowReset={true}
                            min={0}
                            max={200}
                            initialPosition={5}
                            onChange={(new_val) => {
                                props.setAttributes({ list_spacing: new_val })
                            }}
                            value={props.attributes.list_spacing}
                        />
                        <hr />
                        <p style={{ fontWeight: 'bold' }}>Image Margin (px)</p>
                        {<svg width="20" height="20"><path fill="#999" d="M17 1c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17 0h-14c-1.657 0-3 1.343-3 3v14c0 1.657 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M17 0.984h-14c-1.103 0-2 0.897-2 2v0.797h18v-0.797c0-1.103-0.897-2-2-2z"></path></svg>}
                        <RangeControl
                            allowReset={true}
                            min={0}
                            max={100}
                            initialPosition={0}
                            value={props.attributes.img_margin_top}
                            onChange={(new_val) => {
                                props.setAttributes({ img_margin_top: new_val })
                            }}
                        />
                        {<svg width="20" height="20"><path fill="#999" d="M17 1c1.103 0 2 0.897 2 2v14c0 1.103-0.897 2-2 2h-14c-1.103 0-2-0.897-2-2v-14c0-1.103 0.897-2 2-2h14zM17 0h-14c-1.657 0-3 1.343-3 3v14c0 1.656 1.343 3 3 3h14c1.657 0 3-1.343 3-3v-14c0-1.657-1.343-3-3-3v0z"></path><path fill="#575E67" d="M3 19.016h14c1.103 0 2-0.896 2-2v-0.797h-18v0.797c0 1.103 0.897 2 2 2z"></path></svg>}
                        <RangeControl
                            allowReset={true}
                            min={0}
                            max={100}
                            initialPosition={0}
                            value={props.attributes.img_margin_bottom}
                            onChange={(new_val) => {
                                props.setAttributes({ img_margin_bottom: new_val })
                            }}
                        />
                    </PanelBody>
                
                
                
                </InspectorControls>
                <div className="gb-team">
                    <div
                        className="gb-team-content"
                        style={{ textAlign: props.attributes.pos_content }}>
                        {props.attributes.img_ID ? (
                            <div className="gb-team-image-wrapper" style={{ float: props.attributes.imgPos }}>
                                <img
                                    className="gb-team-image-style"
                                    src={props.attributes.img_URL}
                                    alt={props.attributes.img_alt} style={{
                                        width: props.attributes.w_size, borderRadius: props.attributes.image_style,
                                        marginTop: props.attributes.v_alingment, marginTop: props.attributes.img_margin_top,
                                        marginBottom: props.attributes.img_margin_bottom, marginLeft: '10px', marginRight: '10px'
                                    }} />
                            </div>
                        ) : (
                            <MediaUploadCheck  >
                                <MediaUpload
                                    allowedType={['image']}
                                    value={props.attributes.img_ID}
                                    onSelect={select_img}
                                    render={({ open }) => (
                                        <Button className={"button button-large"} onClick={open}>
                                            {__('Upload Image', 'blocks-bakery')}
                                        </Button>
                                    )} ></MediaUpload>
                            </MediaUploadCheck>
                        )}
                        <RichText
                            className="gb-team-heading-title"
                            tagName={props.attributes.heading_title}
                            value={props.attributes.heading_msg}
                            style={{
                                fontSize: props.attributes.heading_size + props.attributes.bgteamheadingtitle,
                                fontFamily: props.attributes.heading_fontfamily, fontWeight: props.attributes.heading_fontweight,
                                lineHeight: props.attributes.heading_lineheight+props.attributes.titlelineheightpx,
                                 color: props.attributes.text_colr,
                                marginBottom: props.attributes.title_spacing,
                            }}
                            onChange={(new_val) => {
                                props.setAttributes({ heading_msg: new_val })
                            }}
                        />
                        <RichText
                            className="gb-team-prefix"
                            tagName='p'
                            value={props.attributes.designation_msg}
                            style={{
                                fontSize: props.attributes.prefix_size + props.attributes.prefixfontpxem,
                                
                                fontFamily: props.attributes.prefix_fontfamily,
                                fontWeight: props.attributes.prefix_fontweight, 
                                lineHeight: props.attributes.prefix_lineheight + props.attributes.prefixlinghtpxem,
                                color: props.attributes.description_clr, marginBottom: props.attributes.description_spacing,
                                fontStyle: 'italic'
                            }}
                            onChange={(new_val) => {
                                props.setAttributes({ designation_msg: new_val })
                            }}
                        />
                        <RichText
                            className="gb-team-description"
                            tagName='p'
                            value={props.attributes.description_msg}
                            style={{
                                padding: 0, margin: 0, fontSize: props.attributes.para_size + props.attributes.descfontempx,
                                fontFamily: props.attributes.para_fontfamily ,
                                 fontWeight: props.attributes.para_fontweight,
                                lineHeight: props.attributes.para_lineheight + props.attributes.descriptionlinghhidpxem, 
                                color: props.attributes.desg_clr,
                                marginBottom: props.attributes.desg_spacing
                            }}
                            onChange={(new_val) => {
                                props.setAttributes({ description_msg: new_val })
                            }}
                        />
                        <div className="bb-team-social-list-main" style={{ display: props.attributes.prefix_display }}>
                        <div className="gb-team-social-list-wrapper" style={{ display: "inline-block"}}>
                            <ul
                                className="gb-team-social-list"
                                style={{ listStyle: "none",display: "flex",
                                margin: 10,
                                padding: 0, }}>
                                <li 
                                style={{  marginRight: props.attributes.list_spacing }}>
                                    <a href={props.attributes.url_icon1} style={{ textDecoration: 'none',width:props.attributes.icon_size + props.attributes.socialfontempxz,height:props.attributes.icon_size + props.attributes.socialfontempxz  }} target="_self" title="" rel="noopener noreferrer" >
                                        <Dashicon id='iconSize1' onMouseOver={changeBackground} onMouseLeave={sameColor} icon={props.attributes.select_control} 
                                        style={{ color: props.attributes.socail_list,
                                        width:props.attributes.icon_size + props.attributes.socialfontempxz,
                                        height:props.attributes.icon_size + props.attributes.socialfontempxz,
                                        fontSize: props.attributes.icon_size + props.attributes.socialfontempxz }} /></a>
                                        
                                        </li>
                                
                                
                                
                                
                                
                                
                                <li style={{  marginRight: props.attributes.list_spacing,marginLeft:props.attributes.list_spacing }}>
                                    <a href={props.attributes.url_icon2} 
                                    style={{  textDecoration: 'none',width:props.attributes.icon_size + props.attributes.socialfontempxz,
                                    height:props.attributes.icon_size + props.attributes.socialfontempxz,
                                    lineHeight:props.attributes.icon_size + props.attributes.socialfontempxz  }} 
                                    target="_self" title="" rel="noopener noreferrer">
                                        <Dashicon id='iconSize2' onMouseOver={changeBackground} onMouseLeave={sameColor}
                                         icon={props.attributes.select_control_icon2} 
                                         style={{ color: props.attributes.socail_list,
                                         width:props.attributes.icon_size + props.attributes.socialfontempxz,
                                         height:props.attributes.icon_size + props.attributes.socialfontempxz,
                                         fontSize: props.attributes.icon_size + props.attributes.socialfontempxz}} /></a>
                                         </li>


                                <li 
                                style={{  
                                    marginRight: props.attributes.list_spacing,
                                    marginLeft:props.attributes.list_spacing  }}>
                                        <a href={props.attributes.url_icon3} 
                                        style={{  textDecoration: 'none',
                                        width:props.attributes.icon_size + props.attributes.socialfontempxz,
                                        height:props.attributes.icon_size + props.attributes.socialfontempxz,
                                        lineHeight:props.attributes.icon_size + props.attributes.socialfontempxz  }}
                                         target="_self" title="" rel="noopener noreferrer">
                                             <Dashicon id='iconSize3' onMouseOver={changeBackground} onMouseLeave={sameColor}
                                              icon={props.attributes.select_control_icon3}
                                               style={{ color: props.attributes.socail_list,
                                               width:props.attributes.icon_size + props.attributes.socialfontempxz,
                                               height:props.attributes.icon_size + props.attributes.socialfontempxz,
                                               fontSize: props.attributes.icon_size + props.attributes.socialfontempxz 
                                               }} />
                                               </a>
                                               
                                               </li>
                                <li 
                                style={{ 
                                     marginRight: props.attributes.list_spacing,
                                     marginLeft:props.attributes.list_spacing  }}>
                                         <a href={props.attributes.url_icon4} 
                                         style={{ 
                                              textDecoration: 'none',
                                              width:props.attributes.icon_size + props.attributes.socialfontempxz,
                                              height:props.attributes.icon_size + props.attributes.socialfontempxz,
                                              lineHeight:props.attributes.icon_size + props.attributes.socialfontempxz  }}
                                               target="_self" title="" rel="noopener noreferrer">
                                        <Dashicon
                                        id='iconSize4'
                                        onMouseOver={changeBackground} 
                                        onMouseLeave={sameColor} 
                                        icon={props.attributes.select_control_icon4}
                                         style={{ 
                                        color: props.attributes.socail_list,
                                        width:props.attributes.icon_size + props.attributes.socialfontempxz,
                                        height:props.attributes.icon_size + props.attributes.socialfontempxz,
                                        fontSize: props.attributes.icon_size + props.attributes.socialfontempxz
                                        }} />
                                        </a>
                                        </li>
                            </ul>
                        </div>
                   </div>
                   
                    </div>
                </div>
            </div>
        ]
    },
    save: (props) => {
        const changeBackground = (e) => {
            e.target.style.color = props.attributes.hover_icon
        }
        const sameColor = (e) => {
            e.target.style.color = props.attributes.socail_list
        }
        return (
            <div className="gb-team" >
                <div
                    className="gb-team-content"
                    style={{ textAlign: props.attributes.pos_content }}>
                    <div className="gb-team-image-wrapper" style={{ float: props.attributes.imgPos, margin: '0px 10px' }} >
                        <img
                            className="gb-team-image-style"
                            src={props.attributes.img_URL}
                            alt={props.attributes.img_alt} style={{
                                width: props.attributes.w_size,borderRadius: props.attributes.image_style,
                                marginTop: props.attributes.v_alingment, marginTop: props.attributes.img_margin_top,
                                marginBottom: props.attributes.img_margin_bottom, marginLeft:'10px',marginRight:'10px'
                            }} />
                    </div>
                    <RichText.Content
                        className="gb-team-heading-title"
                        tagName={props.attributes.heading_title}
                        value={props.attributes.heading_msg}
                        style={{
                            fontSize: props.attributes.heading_size  + props.attributes.bgteamheadingtitle,
                            fontFamily: props.attributes.heading_fontfamily, 
                            fontWeight: props.attributes.heading_fontweight,
                            lineHeight: props.attributes.heading_lineheight+props.attributes.titlelineheightpx,
                             color: props.attributes.text_colr,
                            marginBottom: props.attributes.title_spacing,
                        }}
                      

                    />

                          <RichText.Content
                        
                        className="gb-team-prefix"
                        tagName='p'
                        value={props.attributes.designation_msg}
                        style={{
                            fontSize: props.attributes.prefix_size + props.attributes.prefixfontpxem,
                            fontFamily: props.attributes.prefix_fontfamily,
                            fontWeight: props.attributes.prefix_fontweight, 
                            lineHeight: props.attributes.prefix_lineheight + props.attributes.prefixlinghtpxem,
                            color: props.attributes.description_clr, marginBottom: props.attributes.description_spacing,
                            fontStyle: 'italic'
                        }}
                    />
                    <RichText.Content
                        className="gb-team-description"
                        tagName='p'
                        value={props.attributes.description_msg}
                        style={{
                            padding: 0, margin: 0, fontSize: props.attributes.para_size + props.attributes.descfontempx,
                            fontFamily: props.attributes.para_fontfamily ,
                            fontWeight: props.attributes.para_fontweight,
                            lineHeight: props.attributes.para_lineheight + props.attributes.descriptionlinghhidpxem, 
                            color: props.attributes.desg_clr,
                            marginBottom: props.attributes.desg_spacing
                        }}
                    />
                    <div className="bb-team-social-list-main" style={{ display: props.attributes.prefix_display }}>
                    <div className="gb-team-social-list-wrapper" style={{ display: "inline-block"}}>
                            <ul
                                className="gb-team-social-list"
                                style={{ listStyle: "none",display: "flex",
                                margin: 10,
                                padding: 0, }}>
                                <li 
                                style={{  marginRight: props.attributes.list_spacing }}>
                                    <a href={props.attributes.url_icon1} style={{ textDecoration: 'none',width:props.attributes.icon_size + props.attributes.socialfontempxz,height:props.attributes.icon_size + props.attributes.socialfontempxz  }} target="_self" title="" rel="noopener noreferrer" >
                                        <Dashicon id='iconSize1'  onMouseLeave={sameColor} icon={props.attributes.select_control} 
                                        style={{ color: props.attributes.socail_list,
                                        width:props.attributes.icon_size + props.attributes.socialfontempxz,
                                        height:props.attributes.icon_size + props.attributes.socialfontempxz,
                                        fontSize: props.attributes.icon_size + props.attributes.socialfontempxz }} /></a>
                                        
                                        </li>
                                
                                
                                
                                
                                
                                
                                <li style={{  marginRight: props.attributes.list_spacing,marginLeft:props.attributes.list_spacing }}>
                                    <a href={props.attributes.url_icon2} 
                                    style={{  textDecoration: 'none',width:props.attributes.icon_size + props.attributes.socialfontempxz,
                                    height:props.attributes.icon_size + props.attributes.socialfontempxz,
                                    lineHeight:props.attributes.icon_size + props.attributes.socialfontempxz  }} 
                                    target="_self" title="" rel="noopener noreferrer">
                                        <Dashicon id='iconSize2'  
                                         icon={props.attributes.select_control_icon2} 
                                         style={{ color: props.attributes.socail_list,
                                         width:props.attributes.icon_size + props.attributes.socialfontempxz,
                                         height:props.attributes.icon_size + props.attributes.socialfontempxz,
                                         fontSize: props.attributes.icon_size + props.attributes.socialfontempxz}} /></a>
                                         </li>


                                <li 
                                style={{  
                                    marginRight: props.attributes.list_spacing,
                                    marginLeft:props.attributes.list_spacing  }}>
                                        <a href={props.attributes.url_icon3} 
                                        style={{  textDecoration: 'none',
                                        width:props.attributes.icon_size + props.attributes.socialfontempxz,
                                        height:props.attributes.icon_size + props.attributes.socialfontempxz,
                                        lineHeight:props.attributes.icon_size + props.attributes.socialfontempxz  }}
                                         target="_self" title="" rel="noopener noreferrer">
                                             <Dashicon id='iconSize3'  
                                              icon={props.attributes.select_control_icon3}
                                               style={{ color: props.attributes.socail_list,
                                               width:props.attributes.icon_size + props.attributes.socialfontempxz,
                                               height:props.attributes.icon_size + props.attributes.socialfontempxz,
                                               fontSize: props.attributes.icon_size + props.attributes.socialfontempxz 
                                               }} />
                                               </a>
                                               
                                               </li>
                                <li 
                                style={{ 
                                     marginRight: props.attributes.list_spacing,
                                     marginLeft:props.attributes.list_spacing  }}>
                                         <a href={props.attributes.url_icon4} 
                                         style={{ 
                                              textDecoration: 'none',
                                              width:props.attributes.icon_size + props.attributes.socialfontempxz,
                                              height:props.attributes.icon_size + props.attributes.socialfontempxz,
                                              lineHeight:props.attributes.icon_size + props.attributes.socialfontempxz  }}
                                               target="_self" title="" rel="noopener noreferrer">
                                        <Dashicon
                                        id='iconSize4'
                                         
                                         
                                        icon={props.attributes.select_control_icon4}
                                         style={{ 
                                        color: props.attributes.socail_list,
                                        width:props.attributes.icon_size + props.attributes.socialfontempxz,
                                        height:props.attributes.icon_size + props.attributes.socialfontempxz,
                                        fontSize: props.attributes.icon_size + props.attributes.socialfontempxz
                                        }} />
                                        </a>
                                        </li>
                            </ul>
                        </div>
                        </div>
              
               </div>
            </div>
        )
    }
})